import { useEffect, useState } from 'react';
import classNames from 'classnames';

import styles from './BodyContent.module.scss';

const Collapse = ({
  title,
  children,
  isTitleAvailable,
}) => {
  const [collapsed, setCollapsed] = useState(true);

  const toggleCollapsed = (event) => {
    event.preventDefault();

    if (Boolean(children)) {
      setCollapsed(!collapsed);
    }
  };

  useEffect(() => {
    if (!isTitleAvailable) {
      setCollapsed(false);
    }
  }, [isTitleAvailable]);

  return (
    <>
      {isTitleAvailable && (
        <h2
          className={classNames(styles.Title, {
            [styles.Collapsed]: collapsed,
            [styles.Collapsible]: Boolean(children),
          })}
          onClick={toggleCollapsed}
        >
          {title}
        </h2>
      )}
      {children && (
        <div
          className={classNames(styles.Collapse, {
            [styles.In]: !collapsed,
          })}
        >
          {children}
        </div>
      )}
    </>
  );
};

export default Collapse;
